export const kanbanLocaleText = {
  filterOoo: 'Filtrar...',
  equals: 'Igual a',
  notEqual: 'Diferente de',
  lessThan: 'Menor que',
  greaterThan: 'Maior que',
  lessThanOrEqual: 'Menor ou igual a',
  greaterThanOrEqual: 'Maior ou igual a',
  inRange: 'Entre',
  inRangeStart: 'De',
  inRangeEnd: 'Ate',
  contains: 'Contem',
  notContains: 'Nao contem',
  startsWith: 'Comeca com',
  endsWith: 'Termina com',
  blank: 'Em branco',
  notBlank: 'Nao em branco',
  andCondition: 'E',
  orCondition: 'OU',
  applyFilter: 'Aplicar',
  resetFilter: 'Limpar',
  clearFilter: 'Limpar',
  cancelFilter: 'Cancelar',
  searchOoo: 'Pesquisar...',
  selectAll: 'Selecionar tudo',
  selectAllSearchResults: 'Selecionar todos os resultados',
  addCurrentSelectionToFilter: 'Adicionar selecao ao filtro',
  noMatches: 'Sem resultados',
  columns: 'Colunas',
  filters: 'Filtros',
  pivotMode: 'Modo Pivot',
  groups: 'Grupos de linhas',
  rowGroupColumnsEmptyMessage: 'Arraste colunas para agrupar',
  values: 'Valores',
  valueColumnsEmptyMessage: 'Arraste colunas para agregar',
  pivots: 'Colunas do Pivot',
  pivotColumnsEmptyMessage: 'Arraste colunas para o pivot',
  pinColumn: 'Fixar coluna',
  pinLeft: 'Fixar a esquerda',
  pinRight: 'Fixar a direita',
  noPin: 'Sem fixacao',
  valueAggregation: 'Agregacao',
  autosizeThiscolumn: 'Ajustar esta coluna',
  autosizeAllColumns: 'Ajustar todas as colunas',
  groupBy: 'Agrupar por',
  ungroupBy: 'Desagrupar por',
  resetColumns: 'Resetar colunas',
  expandAll: 'Expandir tudo',
  collapseAll: 'Recolher tudo',
  sortAscending: 'Ordenar crescente',
  sortDescending: 'Ordenar decrescente',
  sortUnSort: 'Remover ordenacao',
  columnMenuTab: 'Menu',
  filterMenuTab: 'Filtro',
  generalMenuTab: 'Geral',
  columnFilter: 'Filtro de coluna',
  pageSizeSelectorLabel: '',
  page: 'Pagina',
  more: 'mais',
  to: 'a',
  of: 'de',
  next: 'Proxima',
  last: 'Ultima',
  first: 'Primeira',
  previous: 'Anterior',
  loadingOoo: 'Carregando...',
  loadingError: 'Erro ao carregar',
  noRowsToShow: 'Nenhum registro encontrado',
  copy: 'Copiar',
  copyWithHeaders: 'Copiar com cabecalhos',
  copyWithGroupHeaders: 'Copiar com cabecalhos de grupo',
  cut: 'Recortar',
  paste: 'Colar',
  export: 'Exportar',
  csvExport: 'Exportar CSV',
  excelExport: 'Exportar Excel',
  sum: 'Soma',
  min: 'Minimo',
  max: 'Maximo',
  none: 'Nenhum',
  count: 'Contagem',
  average: 'Media',
  filteredRows: 'Filtrados',
  selectedRows: 'Selecionados',
  totalRows: 'Total de linhas',
  totalAndFilteredRows: 'Linhas',
  enabled: 'Ativado',
};
